import { HelpPathOutlineIcon, RequestOutlineIcon } from '@ikyucom/design-system-icons-react'
import { LabelNormal } from 'macaron-frontend-ui'
import React from 'react'
import { getHelpRequestUrl } from '~/lib/url'

const RequestReservationLabel: React.FC = () => {
  return (
    <LabelNormal text="">
      <RequestOutlineIcon width={12} height={12} className="mr-1 text-neutral-500" />
      リクエスト予約
      <a
        href={getHelpRequestUrl()}
        target="_blank"
        rel="noopener noreferrer"
        className="ml-1"
        onClick={(e) => e.stopPropagation()}
        aria-label="リクエスト予約とは？"
      >
        <HelpPathOutlineIcon width={12} height={12} className="text-neutral-500" />
      </a>
    </LabelNormal>
  )
}

export default RequestReservationLabel
